export class Product {
    public name!: string
    public slug!: string
    public title!: string
    public nnid!: string
    public description!: string
    public details!: string
    public metaDescription!: string
    public keywords!: string
    public photo01!: string
    public photo01Alt!: string
    public link!: string

    constructor() { }

}
